<div style="padding: 20px; min-width: 360px;">
  <h3 style="margin: 0 0 16px; font-size: 1.05rem; font-weight: 700; color: #1f2937;">Montos R4 Conecta</h3>

  <mat-form-field appearance="outline" class="w-full" style="width: 100%;">
    <mat-label>Tope operativo (R4_MONTO_MIN) VES</mat-label>
    <input matInput type="number" [(ngModel)]="montoMin" min="0" />
    <mat-hint>Techo configurable por operación.</mat-hint>
  </mat-form-field>

  <mat-form-field appearance="outline" class="w-full" style="width: 100%; margin-top: 8px;">
    <mat-label>Tope duro del banco (R4_MONTO_MAX) VES</mat-label>
    <input matInput type="number" [(ngModel)]="montoMax" min="1" />
    <mat-hint>Límite máximo de la API R4 (500.000 Bs/op).</mat-hint>
  </mat-form-field>

  <div style="display: flex; justify-content: flex-end; gap: 8px; margin-top: 20px;">
    <button mat-button (click)="close()" [disabled]="loading">Cancelar</button>
    <button mat-flat-button color="primary" (click)="guardar()" [disabled]="loading">
      {{ loading ? 'Guardando...' : 'Guardar' }}
    </button>
  </div>
</div>
